const CheckoutTypes = require("action-types/checkout");
const CroquisTypes = require("action-types/croquis");
const Deeply = require("utils/deeply");

const internals = {};

module.exports = (state, action) => {
    state = state || internals.initial();

    const { payload, type } = action;

    switch (type) {
        case CheckoutTypes.SELECT_PAYMENT_OPTION:
            return {
                ...state,
                selectedPaymentOptionId: payload.paymentOptionId
            };

        case CheckoutTypes.SELECT_DOWNLOAD_PACKAGE:
            return {
                ...state,
                selectedDownloadPackageId: payload.downloadPackageId,
                // Clear any payment option if we're changing download package
                // because certain payment options won't make sense in the context of
                // others depending on each package's cost (if one is more expensive than
                // the sum the user's credit balance and the credits acquired with the payment option)
                selectedPaymentOptionId:
                    payload.downloadPackageId !==
                    state.selectedDownloadPackageId
                        ? null
                        : state.selectedDownloadPackageId
            };

        case CheckoutTypes.LOAD_PAYMENT_OPTIONS_SUCCESS:
            return {
                ...state,
                paymentOptions: payload.paymentOptions
            };

        case CheckoutTypes.LOAD_DOWNLOAD_PACKAGES_SUCCESS:
            const next = Deeply(state);

            payload.downloadPackages.forEach(pkg => {
                next.set(["downloadPackages", "dict", pkg.id], pkg);
                next.set(["downloadPackages", "byName", pkg.name], pkg.id);
            });

            return next.value();

        case CheckoutTypes.PURCHASE_OPTION_SUCCESS:
            return {
                ...state,
                receipt: payload.payment
            };

        case CroquisTypes.CROQUIS_PURCHASE_SUCCESS:
            return Deeply(state)
                .set("receipt.purchased_id", payload.purchased.id)
                .value();

        case CroquisTypes.PURCHASE_UPGRADE_SUCCESS:
            // TODO Is this right?
            return Deeply(state)
                .set("receipt.purchased_id", payload.upgradedPurchase.id)
                .value();

        case CheckoutTypes.START_TRANSACTION:
            return {
                ...state,
                transaction: payload
            };

        case CheckoutTypes.END_TRANSACTION:
            return {
                ...state,
                selectedDownloadPackageId: null,
                selectedPaymentOptionId: null,
                transaction: null
            };
    }

    return state;
};

internals.initial = () => ({
    selectedPaymentOptionId: null,
    selectedDownloadPackageId: null,
    downloadPackages: {
        dict: {},
        byName: {}
    },
    paymentOptions: [],
    receipt: {},
    /**
     * transaction <object>: { type, id }
     *
     * type <enum, string>: credit (buy credits); purchase (redeem credits for download package of a certain model); upgrade (purchase premium download pacakge for a basic purchase)
     * id <int>: id of model involved in the transaction
     */
    transaction: null
});



// WEBPACK FOOTER //
// ./src/reducers/checkout.js